module.exports = __webpack_public_path__ + "img/img14.a08739aa.png";